<div class="mydownloads-page">
    <div class="common-model-nav">
        <div>
            <div class="stk-nav">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb" style="margin-bottom: 0px; padding-top: 1.5%;">
                        <li class="breadcrumb-item"><a [routerLink]="['/landing-page']">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">My Downloads</li>
                        <li>
              <button
                [attr.Pixel-tracking]="true"
                [attr.Pixel-title]="'Documentation'"
                class="uitk-icon uitk-icon-info_hollow md-icon info-icon-border"
                title="Info"
                (click)="info()"
              ></button>
            </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>

    <div class="uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
        <div class="uitk-c-card uhc-font">
            <div class="uitk_new_header">
                <div class="uitk-l-grid__col--12 stk-container-tabl-header">
                    <div class="stk-header-action row">
                       
                        <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 mydownloads-header-actions">
                            <ng-container *ngIf="mydownloads_dataSource && mydownloads_dataSource.data && mydownloads_dataSource.data.length">
                                <div class="table-search col-md-6 col-sm-6 col-lg-6 col-xl-6 col-xs-12">
                                    <mat-form-field class="data-filter" appearance="outline" >
                                        <input
                                            [(ngModel)]="searchField"
                                            matInput
                                            type="text"
                                            class="capability-search"
                                            placeholder="Search File"
                                            (keyup)="searchDataSet($event)"
                                        />
                                        <img src="../../../../assets/images/searchicon.png" class="lob-view-search-img" alt="Search" />
                                    </mat-form-field>
                                </div>
                                <div class="mydownloads-file-count">
                                    No Of Files : {{ TABLE_CONFIG?.totalItems ?? 0 }}
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <div class="uitk-c-card__content" style="margin-top: 0px !important;">
                <div class="stk-table-container">
                    <app-maintenance-table-v4
                        [TABLE_CONFIG]="TABLE_CONFIG"
                        [COLUMNS]="TABLE_COLUMNS"
                        [SCHEMA]="DATA_SCHEMA"
                        [SORT_CONFIG]="sortConfig"
                        [dataSource]="mydownloads_dataSource"
                        [childDataSource]="mydownloads_dataSource"
                        [BulkUpload]="false"
                        (downloadClickEvent)="onDownloadClick($event)"
                    >
                    </app-maintenance-table-v4>
                </div>
            </div>
        </div>
    </div>
    <div class="my-download-loader" *ngIf="pageLoader">
        <app-loader></app-loader>
    </div>
</div>